/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import Container from "@mui/material/Container";
import useCreateTheme from "../../hooks/useCreateTheme";
import ThemeProvider from "../AppLayout/ThemeProvider";
import { Box } from "../Box";
import { Stack } from "../Stack";
import { FooterProps } from "./IFooter";

const Footer = ({ children, footerTheme }: FooterProps) => {
  const theme = useCreateTheme(footerTheme);
  return (
    <ThemeProvider theme={theme}>
      <Box
        component="footer"
        sx={{
          mt: "auto",
          borderWidth: 0,
          borderTopWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.divider,
        }}
      >
        <Container maxWidth="xl" sx={{ py: 0, px: 0 }} disableGutters >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            {children}
          </Stack>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Footer;
